import React from 'react'
import Nav from 'react-bootstrap/Nav'

export default function VerticalMenuVulnerabilities(props) {

	return (

        <div class="col-10 offset-1 col-lg-4 offset-lg-0 col-xl-3 verticalMenu sticky verticalMenuReporting"> 

        	<p class="capText">How To Disclose a Vulnerability</p>   

        	{props.data.map((sidebar) =>

				<Nav defaultActiveKey="#" className="flex-column">

					<Nav.Link href={sidebar.data_target} class={sidebar.data_target}>

						<div dangerouslySetInnerHTML={{ __html: sidebar.title }}/>

					</Nav.Link>

				</Nav>

        	)}

        	
			
        </div>

	)

}